import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=150f5bf2&"
import script from "./CardBody.vue?vue&type=script&lang=js&"
export * from "./CardBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150f5bf2')) {
      api.createRecord('150f5bf2', component.options)
    } else {
      api.reload('150f5bf2', component.options)
    }
    module.hot.accept("./CardBody.vue?vue&type=template&id=150f5bf2&", function () {
      api.rerender('150f5bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/card-layout/CardBody.vue"
export default component.exports